import React from 'react';
import {deleteSense} from './SenseAction';
import Dict from 'dict-lib';
import {Button, Row, Col} from 'react-bootstrap';
import './../../../../_css/lexeme.css';
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";


export class SenseDelete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        };

        this._handleRemove = this._handleRemove.bind(this);
    }

    _handleRemove() {
        deleteSense(this.props.item);
    }

    render() {

        return <div className="locVar-delete">
            <Row>
                <Col lg={7} md={7} className="popup-label">{Dict.t('ASK_DELETE_SENSE')}</Col>
                <Col lg={5} md={5}>
                    <SCSubmitButton onClick={this._handleRemove} text={Dict.t('YES')}/>
                </Col>
            </Row>
        </div>;
    }


}
